import { isConfigFlagEnabled } from '../config';
import { getShortRenderedValue } from './numberPrecisionUtils';
export function getChipsDisplayValue({ numChips, showChipsAsBbMultiple, bigBlind, truncateZeroDecimals = true }) {
    if (isConfigFlagEnabled('showChipsAsBbMultipleAvailable') && showChipsAsBbMultiple && bigBlind) {
        let bbMultipleStr = (numChips / bigBlind).toFixed(1);
        if (truncateZeroDecimals) {
            while (bbMultipleStr.endsWith('0') && bbMultipleStr.includes('.')) {
                bbMultipleStr = bbMultipleStr.slice(0, bbMultipleStr.length - 1);
            }
            while (bbMultipleStr.endsWith('.')) {
                bbMultipleStr = bbMultipleStr.slice(0, bbMultipleStr.length - 1);
            }
        }
        return { valueStr: bbMultipleStr, suffix: ' bb' };
    }
    return getShortRenderedValue(numChips);
}
export function getChipsDisplayStr(opts) {
    const { valueStr, suffix } = getChipsDisplayValue(opts);
    return `${valueStr}${suffix || ''}`;
}
